import {ACTION} from './constants';
import request from '../../../../../utils/request';
import {requestConfig} from "../../../../../config/apiResource";
import {hideMainLoader,showMainLoader} from "../../../../actions";


export function getCreationContent(nodeId) {
    return dispatch => {
        dispatch(showMainLoader());
        return request(requestConfig.getCreationDetail(nodeId))
            .then((json) => {
                dispatch(hideMainLoader());
                json && dispatch({ type: ACTION.GET_CASH_COMPONENT, data: json.data });
                return json;
            }).catch((error) => {
                dispatch(hideMainLoader());
                console.log("Got Error with component creation data: " + error)
            });
    }
}


export function getCashComponent(formData) {
    return dispatch => {
        dispatch(showMainLoader());
        return request(requestConfig.getCashComponent(formData))
            .then((json) => {
                dispatch(hideMainLoader());
                json && dispatch({ type: ACTION.GET_CASH_DATA , data: json.data });
                return json
            }).catch((error) => {
                dispatch(hideMainLoader());
                console.log("Got Error while fetching cash component: " + error)
            });
    }
}

export function getRebalancingData(formData) {
    return dispatch => {
        dispatch(showMainLoader());
        return request(requestConfig.getRebalancingData(formData))
            .then((json) => {
                dispatch(hideMainLoader());
                json && dispatch({ type: ACTION.GET_REBALANCING_DATA , data: json.data });
                return json
            }).catch((error) => {
                dispatch(hideMainLoader());
                console.log("Got Error while GET_REBALANCING_DATA: " + error)
            });
    }
}

export function getRebalancingDatawise(formData) {
    return dispatch => {
        dispatch(showMainLoader());
        return request(requestConfig.getRebalancingDatawise(formData))
            .then((json) => {
                dispatch(hideMainLoader());
                json && dispatch({ type: ACTION.GET_REBALANCING_DATAWISE , data: json.data });
                return json
            }).catch((error) => {
                dispatch(hideMainLoader());
                console.log("Got Error while GET_REBALANCING_DATAWISE: " + error)
            });
    }
}


